<div @fadeInAnimation>
  <!-- EPS USER -->
  <mat-tab-group *ngIf="sandbox.isEpsUser$ | async" [selectedIndex]="selectedTab$ | async" (selectedTabChange)="tabChanged($event)">
    <mat-tab label="{{ 'SELECT_CUSTOMER.SALES_ORG' | translate }}">
      <tile-page
        [tilesGroupedByLetter]="sandbox.salesOrganisationsGroupedByLetter$ | async"
        noTilesFoundTranslationCode="ERRORS.AUTHORIZATION.NO_SALES_ORGANIZATIONS"
        filterToNarrowTranslationCode="SELECT_CUSTOMER.FILTER.NO_SALES_ORGANISATION"
        [tileIdLoading]="sandbox.salesOrgTileLoading$ | async"
        [clearFilter]="clearFilter"
        (tileClicked)="handleSalesOrganisationClicked($event)"
      ></tile-page>
    </mat-tab>

    <mat-tab label="{{ 'SELECT_CUSTOMER.CUSTOMERS' | translate }}" [disabled]="customersTabDisabled$ | async">
      <tile-page
        [tilesGroupedByLetter]="sandbox.customersGroupedByLetter$ | async"
        noTilesFoundTranslationCode="ERRORS.AUTHORIZATION.NO_CUSTOMERS_IN_SALES_ORGANIZATION"
        filterToNarrowTranslationCode="SELECT_CUSTOMER.FILTER.NO_CUSTOMER"
        [tileIdLoading]="sandbox.selectedCustomerId$ | async"
        [parentTile]="sandbox.selectedSalesOrganisation$ | async"
        [clearFilter]="clearFilter"
        (tileClicked)="handleCustomerClicked($event)"
      ></tile-page>
    </mat-tab>
  </mat-tab-group>
  <!-- CLIENT USER -->
  <tile-page
    *ngIf="(sandbox.isEpsUser$ | async) === false"
    [tilesGroupedByLetter]="sandbox.customersGroupedByLetter$ | async"
    noTilesFoundTranslationCode="ERRORS.AUTHORIZATION.NO_CUSTOMERS"
    filterToNarrowTranslationCode="SELECT_CUSTOMER.FILTER.NO_CUSTOMER"
    [tileIdLoading]="sandbox.selectedCustomerId$ | async"
    (tileClicked)="handleCustomerClicked($event)"
  ></tile-page>
</div>
